import React, { FC } from 'react';
import {
  Modal,
  ModalContainer,
  PrimaryButton,
  Text,
  Box,
  SecondaryButton,
} from 'components';
import { ModalHeading } from 'components/Modal/ModalStyles';

interface PromocodeDifferentOfferProps {
  offerName: string;
  onDismiss: () => void;
  onConfirm: () => void;
}

const PromocodeDifferentOffer: FC<PromocodeDifferentOfferProps> = ({
  offerName,
  onDismiss,
  onConfirm,
}) => {

  return (
    <Modal
      onDismiss={onDismiss}
      aria-labelledby="promo-diff-offer-header"
      aria-describedby="promo-diff-offer-desc"
    >
      <ModalContainer
        onClickClose={onDismiss}
        withShadow
        withWidth="large"
      >
        <Box
          p="small"
          column
        >
          <Box mt="0.83rem" mb="0.7rem" fullWidth>
            <ModalHeading id="promoCode.confirm.header" domId="promo-diff-offer-header" align="left" />
          </Box>

          <Box mt="fine" display="flex" fullWidth lineHeight="1.3">
            <Text id="promoCode.confirm.description" domId="promo-diff-offer-desc" align="left" values={{ offerName }} />
          </Box>

          <Box
            m="large"
            row
            flexBox
            alignItems="center"
            gap="medium"
            width="100%"
            xs-column
            xs-alignItems="stretch"
          >
            <SecondaryButton
              variant="white"
              onClick={onDismiss}
            >
              <Text id="cancel" />
            </SecondaryButton>

            <PrimaryButton variant="brand" onClick={onConfirm}>
              <Text id="changeOffer.continue" />
            </PrimaryButton>
          </Box>
        </Box>
      </ModalContainer>
    </Modal>
  );
};

export default PromocodeDifferentOffer;
